/** @jsxImportSource @emotion/react */
import { Grid, Typography } from '@mui/material';
import React, { useContext, useState } from 'react';
import {  Il8nContext } from '../../Helper/i18n';

export function ProductsBanner(props) {
    const localeText = useContext(Il8nContext)



    return (
        <Grid container item direction={"column"} justifyContent={"start"} alignItems="center"
            css={{ height: "100%", width: "100%", background: "#F5F8FF", borderRadius: "0px 0px 30px 30px", boxShadow: "0px 0px 6px #00000026", paddingBottom: "20px" }}
        >
            <Grid item css={{ marginTop: "15px" }}>
                <Typography css={{ color: "#0098B0", fontWeight: "bold", fontSize: "30px" }}>
                    {localeText?.productBannerProducts}
                </Typography>
            </Grid>
            <Grid container spacing={2} direction="row" justifyContent="center" alignItems="flex-end">
                <Grid item xl={2} lg={2} md={6}>
                    <Grid className='product-wrap' >
                        <Grid>
                            <img src="/images/icon_target.svg" alt="" />
                        </Grid>
                        <Grid>
                            <Typography variant="subtitle" css={{ color: "#525D72", fontWeight: "bold", }}>
                                {localeText?.productBannerTarget}
                            </Typography>
                        </Grid>
                        <Grid>
                            <Typography variant="body2" css={{ color: "#4D6881",height:"40px" }}>
                                {localeText?.productBannerGoal}
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xl={2} lg={2} md={6}>
                    <Grid className='product-wrap'>
                        <Grid>
                            <img src="/images/icon_portfolio_optimizer.svg" alt="" />
                        </Grid>
                        <Grid>
                            <Typography variant="subtitle" css={{ color: "#525D72", fontWeight: "bold" }}>
                                {localeText?.productBannerPortfolio}
                            </Typography>
                        </Grid>
                        <Grid>
                            <Typography variant="body2" css={{ color: "#4D6881",height:"40px" }}>
                                {localeText?.productBannerBalancing}
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xl={2} lg={2} md={6}>
                    <Grid className='product-wrap' >
                        <Grid item>
                            <img src="/images/icon_investment_bucketz.svg" alt="" />
                        </Grid>
                        <Grid item>
                            <Typography variant="subtitle" css={{ color: "#525D72", fontWeight: "bold" }}>
                                {localeText?.productBannerInvestment}
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Typography variant="body2" css={{ color: "#4D6881",height:"40px" }}>
                                {localeText?.productBannerBuild}
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xl={2} lg={2} md={6}>
                    <Grid className='product-wrap' >
                        <Grid item>
                            <img src="/images/icon_DIY_screener.svg" alt="" />
                        </Grid>
                        <Grid item>
                            <Typography variant="subtitle" css={{ color: "#525D72", fontWeight: "bold" }}>
                                {localeText?.productBannerScreener}
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Typography variant="body2" css={{ color: "#4D6881",height:"40px" }}>
                                {localeText?.productBannerstocks}
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}

export default ProductsBanner;